"use client"

import IndexFooter from "@repo/ui/footer"
import { usePathname } from "next/navigation"

/** 预览页等路由不展示 Footer */
const HIDE_FOOTER_PATHS = ["/report-preview"]

export function LocaleLayoutFooter() {
	const pathname = usePathname()
	const hideFooter = HIDE_FOOTER_PATHS.some((path) => pathname.includes(path))

	if (hideFooter) return null

	return <IndexFooter />
}
